export enum CertificationTier {
  Uncertified = 0,
  Basic = 1,
  Diamond = 2
}

export enum OCPPVersionEnum {
  SMARTPOINT_1 = 1,
  VERSION_12 = 120,
  VERSION_15 = 150,
  VERSION_15_SOAP_KEBA = 151,
  VERSION_16_SOAP = 159,
  VERSION_16_JSON = 160,
  VERSION_201_JSON = 201,
  VERSION_21_JSON = 210
}

export type OCPPVersions = keyof typeof OCPPVersionEnum;

export enum SecurityProfileEnum {
  NO_SECURITY = 0,
  BASIC_AUTH = 1,
  BASIC_AUTH_TLS = 2,
  PROFILE_3 = 3
}

export type SecurityProfile = keyof typeof SecurityProfileEnum;

export enum StatusNotificationStatusEnum {
  Available = 0,
  Reserved = 1,
  Unavailable = 2,
  Faulted = 3,
  Preparing = 4,
  Charging = 5,
  SuspendedEVSE = 6,
  SuspendedEV = 7,
  Finishing = 8,
  Finished = 9,
  Occupied = 100,
  ChargingWithoutSession = 200,
  ChargingWithoutSessionSecondChance = 201,
  ChargingWithoutSessionUnlockSent = 202,
  UpdatingFirmware = 203,
  Unknown = 255
}

export type StatusNotificationStatus = keyof typeof StatusNotificationStatusEnum;

export enum LimitationReasonEnum {
  PointLimitation = 0,
  BatteryAlmostFull = 1,
  NumberOfPointsConnected = 2,
  BoxWasTakingLessCurrent = 3,
  NotEnoughCurrentAvailable = 4,
  BatteryAlmostFullButNotEnoughCurrentAvailable = 5,
  WantedMore = 6,
  BoxCantTakeAverage = 7, // The box can't take the average of the station, can occur if the station has some 16 A and some 32 Amps boxes for example.
  Default = 8, // Default value, used for initialization, We shouldn't send any charging profile with this reason
  BoxTookAverage = 9, // We gave the average available to the box
  NotEnoughcurrentAvailableToGetOutOfSuspended = 10, // The car is currently in suspended mode and there is not enough current to give more to the box. The box is going to remain in suspended state
  GaveMoreToTheBoxToGetOutOfSuspended = 11, // We gave more current to the box so it can get out suspended state
  GaveMoreToTheBoxToAvoidGoingBackToSuspended = 12, // We gave more than the previously calculated value to avoid the car going back to suspended (it is currently not suspended but has been previously in the session so we know its suspended limitation)
  CantAvoidGoingBackToSuspended = 13, // We know that this car has a suspended limit but we can't give more to it and it will probably go back to suspended state
  NotEnoughCurrentAvailableToGiveAverage = 14, // There is not enough current left to give average to the box
  CarsLimitationIsTooHighForCheapestCharging = 15, // If for example the normal price is 14 and the car doesn't start to charge under 15
  GaveMinimumAcceptedByTheBox = 16, // We are using the minimum value accepted by the box to charge. This value could be over the average, in that case the priority from the queue will give the box more than average
  NotChargingWithGoodChargingProfile = 17, // Even with a good charging profile the box is not charging, the session must be finished
  GaveLessThanAverage = 18, // The box was taking less than average before so we gave less again
  BoxHasIncreasedSpeed = 19, // The box was taking less than average so the system gave less but the car is getting close to the limit so we'll try to increase a bit again until reaching average
  BackOfTheQueue = 20, // Paused because the car is at the back of the queue for some reason (paused by car, finished)
  BoxWasTakingLessCurrentFormerSuspended = 21 // The box has been suspended before in this session, so we tried to give more than the suspended value and the box wasn't taking that much so we gave a bit less
}

export type LimitationReason = keyof typeof LimitationReasonEnum;

export enum ChargingRateUnitEnum {
  A,
  W
}

export type ChargingRateUnit = keyof typeof ChargingRateUnitEnum;
